/**
 * @license Copyright (c) Microsoft Corporation.  All rights reserved.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _a;
import { FeedbackType } from "./FeedbackType";
import EventAtCapacityImage from "../assets/eventatcapacity.svg";
import EventAtCapacityOnLoadImage from "../assets/eventatcapacity.svg";
import EventNotLiveImage from "../assets/settingup.svg";
import EventRegistrationCanceledImage from "../assets/eventregistrationcanceled.svg";
import EventCancelationLoadErrorImage from "../assets/eventcancelationloaderror.svg";
import FormNotFoundImage from "../assets/success.svg";
import ErrorImage from "../assets/error.svg";
import SubmitSuccessImage from "../assets/success.svg";
import { T } from "../Localization";
import { FormSubmitStatus } from "../Constants/FormStatus";
export var SuccessFeedback = {
    image: SubmitSuccessImage,
    message: "FormSubmitted",
    type: FeedbackType.Success
};
export var WaitlistFeedback = {
    image: SubmitSuccessImage,
    message: "FormSubmittedWaitlist",
    type: FeedbackType.Success
};
export var EventRegistrationCanceledFeedback = {
    image: EventRegistrationCanceledImage,
    message: "EventRegistrationCanceledSuccess",
    type: FeedbackType.Success
};
export var ErrorFeedback = {
    image: ErrorImage,
    message: "FormSubmitError",
    type: FeedbackType.Error
};
export var ReloadFeedback = {
    image: ErrorImage,
    message: "FormSubmitError",
    type: FeedbackType.Error,
    link: { name: "Reload", url: window.location.href }
};
export var EventAtCapacitySubmissionError = {
    image: EventAtCapacityImage,
    message: "SubmissionErrorEventCapacityIsFull",
    type: FeedbackType.Error
};
export var EventNotLiveSubmissionError = {
    image: EventNotLiveImage,
    message: "SubmissionErrorEventNotLive",
    type: FeedbackType.Error
};
export var NoSessionsFoundSubmissionError = {
    image: ErrorImage,
    message: "SubmissionErrorNoSessionsFound",
    type: FeedbackType.Error
};
export var SessionRegistrationRequiredSubmissionError = {
    image: ErrorImage,
    message: "SubmissionErrorSessionRegistrationRequired",
    type: FeedbackType.Error
};
export var SessionValidationFailedSubmissionError = {
    image: ErrorImage,
    message: "SubmissionErrorSessionValidationFailed",
    type: FeedbackType.Error
};
export var SingleSessionRegistrationRequiredSubmissionError = {
    image: ErrorImage,
    message: "SubmissionErrorSingleSessionRegistrationRequired",
    type: FeedbackType.Error
};
export var SessionCapacityIsFullSubmissionError = {
    image: ErrorImage,
    message: "SubmissionErrorSessionCapacityIsFull",
    type: FeedbackType.Error
};
export var EventNotLive = {
    image: EventNotLiveImage,
    message: "EventNotLive",
    type: FeedbackType.Error
};
export var EventRegistrationAlreadyCanceled = {
    image: EventRegistrationCanceledImage,
    message: "EventRegistrationAlreadyCanceled",
    type: FeedbackType.Error
};
export var EventCancelationLoadError = {
    image: EventCancelationLoadErrorImage,
    message: "EventCancelationLoadError",
    type: FeedbackType.Error,
    link: { name: "Reload", url: window.location.href }
};
export var FormNotFound = {
    image: FormNotFoundImage,
    message: "FormNotFound",
    type: FeedbackType.Error
};
export var EventAtCapacityOnLoad = {
    image: EventAtCapacityOnLoadImage,
    message: "EventAtCapacity",
    type: FeedbackType.Error
};
export var ErrorFeedbackMap = (_a = {},
    _a[FormSubmitStatus.EventCapacityIsFull] = EventAtCapacitySubmissionError,
    _a[FormSubmitStatus.EventNotLive] = EventNotLiveSubmissionError,
    _a[FormSubmitStatus.NoSessionsFound] = NoSessionsFoundSubmissionError,
    _a[FormSubmitStatus.SessionRegistrationRequired] = SessionRegistrationRequiredSubmissionError,
    _a[FormSubmitStatus.SessionValidationFailed] = SessionValidationFailedSubmissionError,
    _a[FormSubmitStatus.SingleSessionRegistrationRequired] = SingleSessionRegistrationRequiredSubmissionError,
    _a[FormSubmitStatus.SessionCapacityIsFull] = SessionCapacityIsFullSubmissionError,
    _a[FormSubmitStatus.ValidationError] = ErrorFeedback,
    _a[FormSubmitStatus.InternalServerError] = ErrorFeedback,
    _a);
export function createCorsErrorFeedback(form, client) {
    var _this = this;
    var result = {
        image: ErrorImage,
        message: "FormFailedToLoadCors",
        type: FeedbackType.Error,
        link: {
            name: "LearnMore",
            url: "https://go.microsoft.com/fwlink/?linkid=2215847"
        },
        render: function (container) { return __awaiter(_this, void 0, void 0, function () {
            var enableFormHostingContainer, enableFormHostingMessage, _a, enableFormHostingLink, _b;
            var _this = this;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        enableFormHostingContainer = document.createElement("div");
                        enableFormHostingContainer.className = "enableFormHosting";
                        enableFormHostingMessage = document.createElement("span");
                        _a = enableFormHostingMessage;
                        return [4 /*yield*/, T("EnableFormHostingText")];
                    case 1:
                        _a.textContent = _c.sent();
                        enableFormHostingLink = document.createElement("a");
                        enableFormHostingLink.href = "#";
                        _b = enableFormHostingLink;
                        return [4 /*yield*/, T("EnableFormHostingLinkText")];
                    case 2:
                        _b.innerText = _c.sent();
                        enableFormHostingLink.onclick = function () { return __awaiter(_this, void 0, void 0, function () {
                            var response;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, client.getDomainConfigurationUrl(form.FormApiBaseUrl, form.FormId, window.location.origin)];
                                    case 1:
                                        response = _a.sent();
                                        if (response.domainConfigurationUrl) {
                                            window.location.href = response.domainConfigurationUrl;
                                        }
                                        return [2 /*return*/];
                                }
                            });
                        }); };
                        enableFormHostingContainer.appendChild(enableFormHostingMessage);
                        enableFormHostingContainer.appendChild(enableFormHostingLink);
                        container.appendChild(enableFormHostingContainer);
                        return [2 /*return*/];
                }
            });
        }); }
    };
    return result;
}
